module.exports = __webpack_public_path__ + "img/official_account.9c0b38aa.jpg";